<template>
  <section class="flex level-1"  :class="{mobile:!mobile}">   

        <!-- //TITLE MOBILE -->
          <div class="mobile"  :class="{isMobile:isMobile}"   v-if="mobile && theDestination.name">
            <div class="link">
              <button class="bt btn-back" @click="goBack()">
                <font-awesome-icon :icon="['far', 'angle-left']"/>
              </button>
              <h2>{{general.destinations}} <div class="sub">{{theDestination.name}}</div></h2>
            </div>
            <div class="sep"></div>
          </div>
        <!-- //TITLE MOBILE -->

        <!-- CONTENT-->
        <div class="block__destination content__destination" v-if="theDestination || isLoading">

              <!-- PART MIDDLE -->
                <div class="header entete desktop" v-if="theDestination.name">
                  <PuSkeleton :loading="isLoading" :count="1" width='240px'>
                    <p>{{general.destinations}} <span class="sub">{{theDestination.name}}</span></p>
                  </PuSkeleton>
                </div>

                <!-- SLIDER MOBILE -->
                <div class="block__slider cardSimple mobile">
                  <VueSlickCarousel v-bind="settings">
                    <div  class="wrapper">
                      <!-- <b-img :src="pictures[0]" class="" fluid alt="placeholder"></b-img> -->
                              <imageLoader 
                              :img = pictures[0]
                              theMinHeight = "300px"
                              theWidth = "80vw"
                              ></imageLoader>                          
                    </div>

                    <div  class="wrapper">
                      <!-- <b-img :src="pictures[1]" class=""  alt="placeholder"></b-img>          -->
                              <imageLoader 
                              :img = pictures[1]
                              theMinHeight = "300px"
                              theWidth = "80vw"
                              ></imageLoader>                          
                    </div>

                    <div  class="wrapper">
                      <!-- <b-img :src="pictures[2]" class=""  alt="placeholder"></b-img> -->
                              <imageLoader 
                              :img = pictures[2]
                              theMinHeight = "300px"
                              theWidth = "80vw"
                              ></imageLoader>                          
                    </div>
                  </VueSlickCarousel>
                </div>
                <!-- SLIDER MOBILE -->
                



                <div class="desktop">

                  <div class="block__3imgs">
                        <PuSkeleton :loading="isLoading" :count="1" height="300px">
                          <div>
                              <imageLoader 
                              :img = pictures[0]
                              ></imageLoader>                            
                          </div>
                          <div>
                              <imageLoader 
                              :img = pictures[1]
                              theMinHeight="48%"
                              ></imageLoader>  
                              <Stack></Stack>
                              <imageLoader 
                              :img = pictures[2]
                              theMinHeight="48%"
                              ></imageLoader>                                
                          </div>
                        </PuSkeleton>
                  </div>
                </div>


                <div class="block__flex  mt-4">
                  <div>
                    <PuSkeleton :loading="isLoading" :count="10">
                      <div class="header entete">
                        <p>{{general.destinationDescription}}</p>
                      </div>

                      <div class="content_desc" v-html="theDestination.description">
                      </div>
                    </PuSkeleton>
                  </div>  

                  <div>
                    <PuSkeleton :loading="isLoading" :count="1" height="100px">
                      <b-card class="block__planeDates" title="Période du voyage">
                          <b-list-group>
                            <b-list-group-item>
                              <i class="fas fa-plane-departure blue"></i> 
                              <div class="date">{{ theDestination.startDate | moment(true) }}</div>
                            </b-list-group-item>

                            <b-list-group-item>
                              <i class="fas fa-plane-arrival yellow"></i> 
                              <div class="date">{{ theDestination.endDate | moment(true) }}</div>
                            </b-list-group-item>
                          </b-list-group>
                      </b-card>
                    </PuSkeleton>
                  </div>
                  
                </div>
              <!-- PART MIDDLE -->

        </div>

    <div class="block__destination content__destination" v-else>
      Aucune destination renseigné
    </div>
    <!-- CONTENT-->
      </section>

</template>


<script>
import { mapGetters } from 'vuex'
import ParentMixin from '../../ParentMixin'
import ChallengesMixin from '../challenges/ChallengesMixin'
import ApiService from '../../../../services/ApiService'
import imageLoader from '../../../module/picture/imageLoader'
import Stack from '../../../module/stack/Stack'


export default {
  name:"challengeDestinations",
    components:{ 
      imageLoader,
      Stack
    },
    mixins: [
      ParentMixin,
      ChallengesMixin      
    ],     
    computed: {
      ...mapGetters([
        'getDestination',
        'getGeneral',
        'getChallengeSelected',
      ])
    },
    data () {
      return {
        content:"",
        general:"",
        theDestination:'',
        theDestinationMedia:'',
        pictures:[],
        item:{
          src:'/img/loader.png'
        },         
      }
    },
    props:{
      mobile:{
        type:Boolean,
        default:true
      },    
    },    
    created (){
      this.content = this.getDestination;
      this.general = this.getGeneral;
      this.getData();    
    },    
    methods : { 
      async getData(){
        this.theDestination = await ApiService.getConcoursApi().getDestination(this.getChallengeSelected);
        this.theDestination = this.theDestination.data;
        //
        this.isLoading = false;
        //
        let images = this.theDestination.images;
        images.forEach( (image) => {
            this.pictures.push(ApiService.getMediaApi().get(image.id));
        });   
        
      },

      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      }, 
      onItemClick(){
        this.isMobile ? this.$router.push({ name: 'mobile', params: { subcat: 2 }}).catch(()=>{}) : this.$router.push({ name: 'challenges-classement'}).catch(()=>{});
      },                           
    },
    watch : {
      'getChallengeSelected' : function (){
        this.getData();
        this.isLoading = true;
      },      
    },
      
};
</script>
